import { useQuery } from '@tanstack/vue-query'
import { getQboPromotionConfig } from '@/api/config'
import { computed } from 'vue'

export interface QboPromotionConfig {
  setupUrl: string
}

export function useQboPromotionConfigQuery(enabled: boolean | { value: boolean } = true) {
  const isEnabled = computed(() => (typeof enabled === 'boolean' ? enabled : enabled.value))

  return useQuery({
    queryKey: ['qbo-promotion-config'],
    queryFn: async (): Promise<QboPromotionConfig> => {
      const res = await getQboPromotionConfig()
      return {
        setupUrl: res.data.setup_url,
      }
    },
    enabled: isEnabled,
    staleTime: 10 * 60 * 1000,
  })
}
